export default __webpack_public_path__ + "681dd920375e770907be046a07bc80e3.svg";